import axios from 'axios'

import { getCookie } from '../helpers/cookies'

// Centralized axios construction. Use this factory everywhere instead of direct
// axios.create(...) in domain services.
export function createHttpClient(baseURL, { withCredentials = true } = {}) {
  return axios.create({
    baseURL,
    withCredentials,
  })
}

// Safe shared clients (no cross-auth refresh ownership conflicts).
export const apiClient = createHttpClient('/api')
export const publicApiClient = createHttpClient('/api/public')
export const allauthClient = createHttpClient('/_allauth/browser/v1')

allauthClient.interceptors.request.use((config) => {
  const csrfToken = getCookie('csrftoken')

  if (csrfToken && config.method !== 'get') {
    config.headers['X-CSRFToken'] = csrfToken
  }

  return config
})

export function attachBearerInterceptor(client, getToken) {
  // Helper for lightweight bearer attachment. Keep refresh-retry logic owned
  // by each auth mode service to avoid cross-mode interceptor coupling.
  client.interceptors.request.use(
    (config) => {
      const token = String(getToken?.() || '').trim()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => Promise.reject(error)
  )
}
